<template>
  <div>
    <div v-if="showBasicSubscriptionCard" class="card mt-3" header-bg-variant="white">
      <div class="card-body">
        <div class="row mb-4">
          <div class="col-auto">
            <h5 class="mb-0 pb-0">
              <span data-test-hook="basic-plan-name">
                {{ $t('xMobileLinkBasic') }}
              </span>
            </h5>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col">
            <span data-test-hook="plan-cost-header-text">
              {{ $t('xPlanStatus') }}
            </span>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col">
            <strong v-if="country.includes(productsOnBasicSubscription[0].country)" data-test-hook="plan-cost">
              {{ $t('xCurrentlyNotSubscribedToPlan') }}
            </strong>
            <strong v-else data-test-hook="plan-cost">
              {{ $t('xMLPNotAvailableInYourRegion') }}
            </strong>
          </div>
        </div>

        <div class="accordion" role="tablist" style="width:100%;">
          <div class="accordion-wrapper" style="border: 1px solid lightgrey; padding: 10px; border-radius: 10px;">
            <div v-b-toggle.collapse-hasProductNoSubscription>
              <div class="row align-items-center no-gutters">
                <div class="col align-items-center">
                  <i class="fa-regular fa-circle-info pr-2"></i><strong>{{ $t('xProductsAndFeatures') }}</strong>
                </div>
                <div class="col-auto">
                  <i class="fas fa-chevron-down when-closed"></i>
                  <i class="fas fa-chevron-up when-open"></i>
                </div>
              </div>
            </div>
            <b-collapse id="collapse-hasProductNoSubscription">
              <div class="row">
                <div class="col">
                  <hr class="mx-0 px-0" />
                </div>
              </div>
              <div
                v-if="
                  productsOnBasicSubscription !== undefined &&
                    productsOnBasicSubscription !== null &&
                    productsOnBasicSubscription.find(apparatus => apparatus.apparatusType === hsbApparatusType)
                "
              >
                <div class="row mb-2">
                  <div class="col">
                    <p class="mb-0 pb-0">
                      <strong data-test-hook="products-included-text">
                        {{ $t('xProductsWithBasicFeatures') }}
                      </strong>
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-0">
                    <ul
                      id="productsCoveredSingleHomePremium"
                      style="list-style-type: none; padding-inline-start: 13px;"
                    >
                      <li v-for="(apparatus, index) in productsOnBasicSubscription" :key="index">
                        <div v-if="apparatus.apparatusType === hsbApparatusType" class="mb-1">
                          <i :class="getApparatusIcon(apparatus.apparatusType)"></i>&nbsp;&nbsp;{{
                            apparatus.apparatusName
                          }}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col">
                    <p class="mb-0 pb-0">
                      <strong data-test-hook="features-included-text">
                        {{ $t('xFeaturesIncludedInBasicPlan') }}
                      </strong>
                    </p>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col icon-and-text">
                    <i class="fa-kit fa-fw fa-generator"></i>
                    <span data-test-hook="features-included-list">
                      {{ $t('xFeaturesIncludedWiFiAnnuallySubscriptionFeature1') }}
                    </span>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  productsOnBasicSubscription !== undefined &&
                    productsOnBasicSubscription !== null &&
                    productsOnBasicSubscription.find(apparatus => apparatus.apparatusType === fuelTankApparatusType)
                "
              >
                <div class="row mb-2">
                  <div class="col">
                    <p class="mb-0 pb-0">
                      <strong data-test-hook="products-included-text">
                        {{ $t('xProductsNotSupported') }}
                      </strong>
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-0">
                    <ul
                      id="productsCoveredSingleHomePremium"
                      style="list-style-type: none; padding-inline-start: 13px;"
                    >
                      <li v-for="(apparatus, index) in productsOnBasicSubscription" :key="index">
                        <div v-if="apparatus.apparatusType === fuelTankApparatusType" class="mb-1">
                          <i :class="getApparatusIcon(apparatus.apparatusType)"></i>&nbsp;&nbsp;{{
                            apparatus.apparatusName
                          }}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="row mt-0 mb-2">
                <div class="col">
                  <p class="mb-0 pb-0">
                    <strong data-test-hook="features-included-text">
                      {{ $t('xFeaturesNotIncluded') }}
                    </strong>
                  </p>
                </div>
              </div>
              <div
                class="row mb-3"
                v-if="
                  productsOnBasicSubscription !== undefined &&
                    productsOnBasicSubscription !== null &&
                    productsOnBasicSubscription.find(apparatus => apparatus.apparatusType === hsbApparatusType)
                "
              >
                <div class="col icon-and-text">
                  <i class="fa-kit fa-fw fa-generator"></i>
                  <span data-test-hook="features-included-list">
                    {{ $t('xFeatureNotIncludedFeaturesHSB') }}
                  </span>
                </div>
              </div>
              <div
                v-if="
                  productsOnBasicSubscription !== undefined &&
                    productsOnBasicSubscription !== null &&
                    productsOnBasicSubscription.find(apparatus => apparatus.apparatusType === fuelTankApparatusType)
                "
                class="row mb-3"
              >
                <div class="col icon-and-text">
                  <span data-test-hook="features-included-list">
                    <i :class="getApparatusIcon(fuelTankApparatusType)"></i>
                    {{ $t('xFeatureNotIncludedFeaturesFuelTank') }}
                  </span>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>

        <button
          v-if="country.includes(productsOnBasicSubscription[0].country)"
          type="button"
          class="btn btn-warning mt-3"
          @click="openSubscribePremium()"
          data-test-hook="openSubscribePremiumMonitoringBtn"
          :disabled="disableUpgradeButton"
        >
          {{ $t('xUpgradePremium') }}
        </button>
      </div>
    </div>
    <AccountNeedsAttentionModal />
    <PremiumEnrollmentBeforeYouUpgradeModal
      :apparatusesIncludedInUpgrade="productsOnBasicSubscription"
      @openSubscriptionModal="openSubscriptionModal"
    />
    <UpgradeSubscriptionsModal
      modal-id="upgrade-subscription-modal-hsb"
      :apparatus-id="generatorId"
      :apparatus-list="apparatusesToUpgrade"
      :accountProfile="accountProfile"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

import * as Constants from '@/constants'

import AccountNeedsAttentionModal from './AccountNeedsAttentionModal.vue'
import PremiumEnrollmentBeforeYouUpgradeModal from './PremiumEnrollmentBeforeYouUpgradeModal.vue'
import UpgradeSubscriptionsModal from '../../Enrollment/Subscription/UpgradeSubscriptionsModal.vue'

export default {
  components: {
    AccountNeedsAttentionModal,
    PremiumEnrollmentBeforeYouUpgradeModal,
    UpgradeSubscriptionsModal
  },
  props: [
    'accountProfile',
    'productsOnBasicSubscription',
    'apparatusesOnExistingSubscription',
    'showBasicSubscriptionCard',
    'legacySubscriptionList',
    'disableUpgradeButton'
  ],
  data() {
    return {
      apparatusDetails: null,
      apparatusId: null,
      generatorId: null
    }
  },
  computed: {
    ...mapState({
      apparatuses: state => state.apparatus.apparatuses
    }),
    hsbApparatusType() {
      return Constants.HsbApparatusType
    },
    fuelTankApparatusType() {
      return Constants.FuelTankApparatusType
    },
    country() {
      return Constants.CountriesGetPaidSubs
    },
    apparatusesToUpgrade() {
      return this.apparatuses.filter(apparatus => {
        if (
          this.productsOnBasicSubscription.find(app => app.apparatusId === apparatus.apparatusId) ||
          this.apparatusesOnExistingSubscription.find(app => app.apparatusId === apparatus.apparatusId) ||
          this.legacySubscriptionList?.some(
            legacySub =>
              legacySub.subscriptionStatus === Constants.SubscriptionActive &&
              legacySub.apparatusId === apparatus.apparatusId
          )
        ) {
          return apparatus
        }
      })
    }
  },
  methods: {
    openSubscribePremium() {
      if (
        this.productsOnBasicSubscription?.filter(
          product => product.apparatusType === Constants.HsbApparatusType && product.isDealerManaged === false
        ).length > 2 ||
        this.productsOnBasicSubscription?.filter(product => product.apparatusType == Constants.FuelTankApparatusType)
          .length > 4
      ) {
        this.openModal('account-needs-attention')
      } else {
        this.apparatusesIncludedInUpgrade = this.productsOnBasicSubscription
        if (this.apparatusesIncludedInUpgrade?.length > 1) {
          this.openModal('premium-enrollment-before-you-upgrade-modal')
        } else if (this.apparatusesIncludedInUpgrade?.length === 1) {
          this.openSubscriptionModal()
        }
      }
    },

    async openSubscriptionModal() {
      this.generatorId = this.apparatusesIncludedInUpgrade[0].apparatusId
      this.$bvModal.show('upgrade-subscription-modal-hsb')
    },

    getApparatusIcon(type) {
      switch (type) {
        case Constants.HsbApparatusType:
          return 'fa-kit fa-fw fa-generator'
        case Constants.FuelTankApparatusType:
          return 'fa-kit fa-fw fa-tank'
        default:
          return 'fa-kit fa-fw fa-generator'
      }
    }
  }
}
</script>
